import {Controller} from "@hotwired/stimulus"
import {optionsFor} from "../components/froala_presets.js"

// Froala 2 is a jQuery plugin loaded by Sprockets, so it is reached through the global jQuery
// it registered on, never through an import (a second jQuery would not carry the plugin).
export default class extends Controller {
  static values = {preset: {type: String, default: "note"}, submitOn: String}

  connect() {
    const jq = this.jquery
    if (!jq) return

    // A moved element reconnects with its editor intact; a second one would loop on destroy.
    this.instance = jq(this.element).data("froala.editor") || this.build(jq)
  }

  disconnect() {
    // Stimulus also disconnects on a move. Froala's destroy re-inserts the textarea, so
    // destroying a still-connected element starts an endless disconnect/connect loop.
    if (!this.instance || this.element.isConnected) return
    this.instance.destroy()
    this.instance = null
  }

  build(jq) {
    const wrapper = jq(this.element).froalaEditor(optionsFor(this.presetValue))
    if (this.submitOnValue) {
      wrapper.on(`froalaEditor.${this.submitOnValue}`, () => this.submitForm())
    }
    // jQuery's .html()/.remove() wipe the data store before disconnect runs, so the instance is
    // kept here rather than looked up through froalaEditor("destroy").
    return wrapper.data("froala.editor")
  }

  submitForm() {
    const form = this.element.form
    if (form) form.requestSubmit()
  }

  get jquery() {
    const jq = window.jQuery
    return jq && jq.fn && typeof jq.fn.froalaEditor === "function" ? jq : null
  }
}
